import { BaseDialog, FlexBox } from '@airship-platform/jam-web/components';
import { Divider } from '@mui/material';
import { Fragment } from 'react/jsx-runtime';
import { InstalledEquipmentResponseExtended } from '../details-page/ExistingSystem';
import SeeDetailsExistingSystem from './SeeDetailsExistingSystem';

const SeeAllEquipmentsExistingSystemModal: React.FC<{
  open: boolean;
  equipments: InstalledEquipmentResponseExtended[];
  onClose: () => void;
}> = ({ open, equipments, onClose }) => (
  <BaseDialog open={open} title={'Existing system'} onClose={() => onClose()}>
    <FlexBox flexDirection="column" gap={3}>
      {equipments.map((equipment) => (
        <Fragment key={equipment.locationEquipmentId}>
          <SeeDetailsExistingSystem equipment={equipment} />
          <Divider />
        </Fragment>
      ))}
    </FlexBox>
  </BaseDialog>
);
export default SeeAllEquipmentsExistingSystemModal;
